import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert.js';
import { getCoachPools } from '@/lib/api-calls.js';
import { cn } from '@/lib/tailwind-utils.js';
import { useFeatureFlag } from '@airreading/feature-flags/web';
import { useQuery } from '@tanstack/react-query';
import { Lightbulb } from 'lucide-react';

export function ReservedTeacherPoolsBanner({ className }: { className?: string }) {
  const teacherPoolsEnabled = useFeatureFlag('teacher-pool', false);
  const { data } = useQuery({
    ...getCoachPools(),
    enabled: teacherPoolsEnabled,
  });
  const activePools = (data?.pools ?? []).filter((pool) => pool.isActive);

  if (!teacherPoolsEnabled || activePools.length === 0) {
    return null;
  }

  return (
    <Alert
      variant="alert"
      className={cn('border-orange-300 bg-orange-100 text-orange-700 [&>svg]:text-orange-700', className)}
      data-testid="generate-classes-banner-reserved-pools"
    >
      <Lightbulb className="h-4 w-4" aria-hidden="true" />
      <AlertTitle className="text-sm font-semibold text-orange-700">Reserved teacher pools apply</AlertTitle>
      <AlertDescription className="text-sm text-orange-700">
        <p>
          Teachers in active reserved pools will be assigned only when no eligible non-reserved teacher can be assigned.
        </p>
        <p className="mt-3 font-semibold">Active pools:</p>
        <ul className="mt-1 list-disc pl-5">
          {activePools.map((pool) => (
            <li key={pool.id}>{pool.title}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
